export interface StatusDropdownProps {
  jobOrderId?: number;
  candidateId: number;
  candidateStatus: string;
  emailIds?: string[];
  candidateName?: string;
  resumeData: any;
  onSuccess?: () => void;
}

export interface Option {
  label: string;
  value: string;
}

export interface MailTemplateRequest {
  mailTemplate: string,
  jobOrderId: number,
  candidateId: number
}

export enum CandidateMailStatus {
  RATE_CONFIRMATION_WITH_CONSULTANCY = 'RATE_CONFIRMATION_WITH_CONSULTANCY',
  RTR_FORM_WITH_CANDIDATE = 'RTR_FORM_WITH_CANDIDATE',
  CANDIDATE_REQUESTED_JOBDESCRIPTION = 'CANDIDATE_REQUESTED_JOBDESCRIPTION',
  AUTHORIZATION_FORM = 'AUTHORIZATION_FORM',
  ON_VOICEMAIL_1 = 'ON_VOICEMAIL_1',
  ON_VOICEMAIL_2 = 'ON_VOICEMAIL_2',
  ON_VOICEMAIL_3 = 'ON_VOICEMAIL_3',
  ON_VOICEMAIL_Final = 'ON_VOICEMAIL_Final',
  UPDATE_INTERVIEW = 'UPDATE_INTERVIEW',
  CANCEL_INTERVIEW = 'CANCEL_INTERVIEW',
  REMINDER_INTERVIEW = 'REMINDER_INTERVIEW',
  SCHEDULE_CLIENT_INTERVIEW = 'SCHEDULE_CLIENT_INTERVIEW',
  RESUME_SUBMITTED_FOR_PRESCREENING = 'RESUME SUBMITTED FOR PRESCREENING',
  PLACED_WITH_MROADS = 'PLACED WITH MROADS',
  FACE_2_FACE = 'FACE_2_FACE',
  ONBOARDING_GATE_PASS = 'ONBOARDING_GATE_PASS',
  REJECTED = 'REJECTED',
}

export enum CandidateActiveStatus {
  FOLLOW_UP = 'FOLLOW UP',
  NOT_REACHABLE = 'NOT REACHABLE',
  SUBMITTED_TO_CLIENT = 'SUBMITTED TO CLIENT',
  COMPLETED_CLIENT_INTERVIEW = 'COMPLETED CLIENT INTERVIEW',
  PLACED_WITH_MROADS = 'PLACED WITH MROADS',
  REQUIREMENT_CLOSED = 'REQUIREMENT CLOSED',
  NOT_SUITABLE_FOR_POSITION = 'NOT SUITABLE FOR POSITION',
  SCHEDULE_PANNA_INTERVIEW = 'SCHEDULE_PANNA_INTERVIEW',
  NOT_INTERESTED_TO_RELOCATE = 'NOT_INTERESTED_TO_RELOCATE',
  FAKE_CANDIDATE = 'FAKE_CANDIDATE',
  CANDIDATE_ALREADY_SUBMITED_BY_OTHER_VENDOR = 'CANDIDATE_ALREADY_SUBMITED_BY_OTHER_VENDOR',
  LOOKING_FOR_HIGHER_RATE = 'LOOKING_FOR_HIGHER_RATE',
  SUBMITTED_TO_CLIENT_BY_OTHER_VENDOR = 'SUBMITTED_TO_CLIENT_BY_OTHER_VENDOR',
  SCHEDULE_MLIVE_INTERVIEW = 'SCHEDULE_MLIVE_INTERVIEW',
  NOT_LOOKING_FOR_CHANGE = 'NOT_LOOKING_FOR_CHANGE',
  NO_CONTACT_INFO = 'NO_CONTACT_INFO',
  DISCUSSING = 'DISCUSSING',
  REJECTED_BY_CLIENT = 'REJECTED_BY_CLIENT',
  RESUME_SUBMITTED_FORREVIEW = 'RESUME SUBMITTED FORREVIEW',
  ASSIGNMENT_STARTED = 'ASSIGNMENT_STARTED',
  ASSIGNMENT_COMPLETED = 'ASSIGNMENT_COMPLETED',
  PHONE_CALL = 'PHONE CALL',
  CLEARED_FOR_NEXT_STEPS = 'CLEARED_FOR_NEXT_STEPS',
  CLAIMED = 'CLAIMED',
  LOOKING_C2C_ONLY = 'LOOKING_C2C_ONLY',
  ADD_COMMENT = 'ADD_COMMENT',
  DO_NOT_HIRE = 'DO_NOT_HIRE',
}

export interface SchedulePannaRequest {
  candidateId: number;
  interviewPositionId: number;
  expiry: number;
  jobOrderId: number;
}

export interface ScheduleLiveRequest {
  candidateId: number;
  interviewerSlotId: number;
  jobOrderId: number;
}
